import {IconModes} from './@types';

const ICON_MODES: IconModes = {
    good:       'check_circle',
    wrong:      'report_problem',
    attention:  'error_outline',
    default:    'info'
};


export {
    ICON_MODES
}
